module.exports = __webpack_public_path__ + "media/images/emblems/Dietikon-blazon-e136c5e3a15645bf181deb5318cf53a7.svg";